"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixtureUseType = void 0;
var FixtureUseType;
(function (FixtureUseType) {
    FixtureUseType[FixtureUseType["Consumption"] = 0] = "Consumption";
    FixtureUseType[FixtureUseType["Non-Consumption"] = 1] = "Non-Consumption";
})(FixtureUseType = exports.FixtureUseType || (exports.FixtureUseType = {}));
//# sourceMappingURL=FixtureUseType.js.map